/* eslint-disable */
/**
 * Creates an injectable function that will be able to handle the life cycle of an async action creator
 * @param {Store} store The state management `store`
 * @returns {FromPromise} The `dispatch` aware injectable
 */
const createFromPromise = ({ dispatch }) => async (promise, meta, [FROM_PROMISE, FROM_PROMISE_COMPLETE, FROM_PROMISE_ERROR, FROM_PROMISE_SUCCESS]) => {
  dispatch({
    complete: false,
    error: null,
    meta,
    payload: null,
    type: FROM_PROMISE,
  });
  let isCancelled = false;
  /** @type {ActionError | ActionSuccess} */
  let errorOrSuccessAction;
  try {
    const payload = await promise;
    errorOrSuccessAction = dispatch({
      complete: false,
      error: null,
      meta,
      payload,
      type: FROM_PROMISE_SUCCESS,
    });
  } catch (error) {
    const errorData = error.response || error;
    if (error.name === `HttpCancelled`) {
      isCancelled = true;
    }
    if (!isCancelled) {
      errorOrSuccessAction = dispatch({
        complete: false,
        error: errorData,
        meta,
        payload: null,
        type: FROM_PROMISE_ERROR,
      });
    }
  }
  return dispatch({
    ...errorOrSuccessAction,
    complete: true,
    type: FROM_PROMISE_COMPLETE,
  });
};

export default createFromPromise;
